class MFRPressLogoCarousel {
  constructor(i, e, options) {
    this.$index = i;
    this.$element = $(e);

    this.options = options;

    this.selectors = {
      pressCarousel: ".press-carousel",
      logoSlider: ".logos",
      logoSlides: ".logos > div",
    };

    this.init();
  }

  init() {
    this.$pressCarousel = this.$element.find(this.selectors.pressCarousel);
    this.$logoSlider = this.$element.find(this.selectors.logoSlider);

    this.initCarousel();
    // this.initNavSlider();
  }

  initCarousel() {
    this.$pressCarousel.flickity({
      ...this.options,
      on: {
        ready: () => this.initNavSlider()
      }
    });
  }

  initNavSlider() {
    const options = {
      asNavFor: this.$pressCarousel.get(0),
      selectedAttraction: 0.1,
      friction: 0.55,
      prevNextButtons: false,
      contain: true,
      cellAlign: "center",
      pageDots: false,
      wrapAround: false,
      groupCells: false,
      freeScroll: false,
    };

    if (this.isMobile()) {
      options.contain = false;
      options.wrapAround = true;
    }

    this.$logoSlider.flickity({
      ...options,
      on: {
        change: (index) => {
          if( $( window ).width() <= 639 ) {
            this.$pressCarousel.flickity( "select", index );
          }
        }
      }
    });
  }

  isMobile() {
    return window.innerWidth < 640;
  };
}